import React from "react";
import { renderInline } from "./sr-chat-inline";
import { SrChatTable } from "./sr-chat-table";

type Block =
    | { type: "table"; lines: string[] }
    | { type: "text"; lines: string[] };

const parseBlocks = (content: string): Block[] => {
    const lines = content.replace(/\r\n/g, "\n").split("\n");
    const blocks: Block[] = [];
    let i = 0;

    while (i < lines.length) {
        const line = lines[i];
        const looksTable =
            line.includes("|") &&
            i + 1 < lines.length &&
            /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?\s*$/.test(lines[i + 1].trim());

        if (looksTable) {
            const tableLines: string[] = [];
            while (i < lines.length && lines[i].includes("|")) {
                tableLines.push(lines[i]);
                i += 1;
            }
            blocks.push({ type: "table", lines: tableLines });
            continue;
        }

        const textLines: string[] = [];
        while (
            i < lines.length &&
            !(
                lines[i].includes("|") &&
                i + 1 < lines.length &&
                /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?\s*$/.test(
                    lines[i + 1].trim()
                )
            )
        ) {
            textLines.push(lines[i]);
            i += 1;
        }
        if (textLines.length) blocks.push({ type: "text", lines: textLines });
    }
    return blocks;
};

type Props = { content: string; isUser?: boolean };

export const SrChatMarkdown: React.FC<Props> = ({ content, isUser }) => {
    const blocks = parseBlocks(content);

    return (
        <div className="sr-chat-bubble space-y-2 break-words">
            {blocks.map((block, bi) => {
                if (block.type === "table") {
                    return (
                        <SrChatTable
                            key={bi}
                            lines={block.lines}
                            isUser={isUser}
                        />
                    );
                }
                return (
                    <div key={bi} className="whitespace-pre-wrap">
                        {block.lines.map((line, li) => (
                            <React.Fragment key={li}>
                                {li > 0 && "\n"}
                                {renderInline(line, `${bi}-${li}`)}
                            </React.Fragment>
                        ))}
                    </div>
                );
            })}
        </div>
    );
};
